import { filter, map } from 'rxjs/operators'
import { ofType, StateObservable, ActionsObservable } from 'redux-observable'
import { roomTypes } from '../../../actions/room/roomTypes'
import { State, ReduxAction } from '../../../reducers/reducerType'
import { adjustParticipantVideoQuality } from '../../../actions/tracks/trackActions'
import username from '../../../../lib/username'

const checkVideoQuality$ = (actions$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => actions$.pipe(
  ofType(roomTypes.PARTICIPANT_CONNECTED, roomTypes.PARTICIPANT_DISCONNECTED),
  filter(() => username.isPresenter(state$.value.config.username || '')),
  map(() => adjustParticipantVideoQuality())
)

export default checkVideoQuality$
